import { defineComponent, ref, useAttrs, onMounted, onBeforeUnmount, watch, openBlock, createElementBlock, createVNode, Transition, withCtx, withDirectives, mergeProps, unref, createCommentVNode, createElementVNode, vShow, normalizeClass, normalizeStyle, toDisplayString, createBlock } from "vue";
import { CompassSpinner } from "@rei/spinner";
import { CdrBreakpointLg } from "@rei/cdr-tokens";
const _hoisted_1 = ["media", "srcset"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  key: 1,
  class: "pdp-sr-only"
};
const _hoisted_5 = {
  class: "generic-lazy-loader__spinner-wrapper"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "GenericLazyImageLoader",
  props: {
    imageSrc: {
      default: ""
    },
    lazy: {
      type: Boolean,
      default: false
    },
    lazyOpts: {
      default: () => ({
        // IntersectionObserver options object
        observerOpts: {},
        // used in IntersectionObserver callback
        intersectionRatio: 0
      })
    },
    overrideInitialLoad: {
      type: Boolean,
      default: false
    },
    title: {
      default: ""
    },
    showXlBreakpoint: {
      type: Boolean
    },
    isHero: {
      type: Boolean,
      default: false
    },
    xlImageSrc: {
      default: ""
    }
  },
  emits: ["imageLoaded"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const hasError = ref(false);
    const initialLoad = ref(!props.overrideInitialLoad && !props.lazy);
    const IO = ref(null);
    const isLoading = ref(true);
    const shouldLoad = ref(!props.lazy);
    const container = ref(null);
    const attrs = useAttrs();
    onMounted(() => {
      if (props.lazy && window.IntersectionObserver && container.value) {
        IO.value = new window.IntersectionObserver(observeCb, {
          ...props.lazyOpts.observerOpts
        });
        if (IO.value) IO.value.observe(container.value);
      } else {
        shouldLoad.value = true;
      }
    });
    onBeforeUnmount(() => {
      if (IO.value) IO.value.disconnect();
    });
    watch(() => props.imageSrc, () => {
      setTimeout(() => {
        const newImg = document.createElement("img");
        newImg.src = props.imageSrc;
        const imageState = newImg.complete === true;
        isLoading.value = !imageState;
      }, 10);
    });
    function handleError() {
      hasError.value = true;
    }
    function handleLoad() {
      isLoading.value = false;
      initialLoad.value = false;
      emit("imageLoaded");
    }
    function observeCb(entries) {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= props.lazyOpts.intersectionRatio) {
          shouldLoad.value = true;
          if (IO.value) IO.value.disconnect();
        }
      });
    }
    __expose({
      hasError
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "container",
        ref: container,
        class: "generic-lazy-loader"
      }, [createVNode(Transition, {
        name: "fade-image"
      }, {
        default: withCtx(() => [shouldLoad.value ? withDirectives((openBlock(), createElementBlock("picture", mergeProps({
          key: 0
        }, _ctx.$attrs, {
          key: "image"
        }), [_ctx.showXlBreakpoint && _ctx.isHero ? (openBlock(), createElementBlock("source", {
          key: 0,
          media: `(min-width:${unref(CdrBreakpointLg)}px)`,
          srcset: _ctx.xlImageSrc
        }, null, 8, _hoisted_1)) : createCommentVNode("", true), createElementVNode("img", {
          src: _ctx.imageSrc,
          class: "generic-lazy-loader__img",
          onLoad: handleLoad,
          onError: handleError
        }, null, 40, _hoisted_2)], 16)), [[vShow, shouldLoad.value && initialLoad.value || !isLoading.value]]) : createCommentVNode("", true)]),
        _: 1
      }), isLoading.value && unref(attrs).width && unref(attrs).height ? (openBlock(), createElementBlock("img", {
        key: 0,
        class: normalizeClass(["generic-lazy-loader__img", unref(attrs).class]),
        src: _ctx.imageSrc,
        alt: unref(attrs).alt,
        style: normalizeStyle({
          visibility: "hidden",
          width: `${unref(attrs).width}px`,
          height: "auto"
        })
      }, null, 14, _hoisted_3)) : createCommentVNode("", true), isLoading.value ? (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(_ctx.title || "image") + " loading ", 1)) : createCommentVNode("", true), createVNode(Transition, {
        name: "fade-spinner",
        appear: ""
      }, {
        default: withCtx(() => [createElementVNode("div", _hoisted_5, [isLoading.value && !initialLoad.value ? (openBlock(), createBlock(unref(CompassSpinner), {
          key: "spinner",
          class: "generic-lazy-loader__spinner"
        })) : createCommentVNode("", true)])]),
        _: 1
      })], 512);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericLazyImageLoader3.mjs.map
